//DONE
// shrink default image size < done
//FIX blending options on mobile < probably just remove black paper
//RECALC THE SIZES > L might not be big enough. Column count seems off < fuck it
//Max Size radio hidden element then create fake one to move up in the UI < not possible
//hide scale line when zooming < done, opacity goes to 0 at the same speed as zoom
//fix initial layouts so it's not getting cut off on the side < done. changed scale to 108%
//make product image sticky on mobile < done
//FIX pattern12 when you switch sizes < disabled size switching for pattern 12
//Fix how scale is displayed on mobile < done
//add code to update default pattern based on variant id < done but not using variant id. calls function instead on leaod
//figure out why upload buttons aren't appearing properly < done
//Hide upload fields on load < done
//FIX Change image functionality < done
//add delay so the upload image function doesn't run until the ID has been assigned to the upload button < done, event listeners added when user selects first pattern
//add overlay saying 'select pattern style' to begin and make disappear < done
//disable hover zoom on intro text < done
//FIX ROTATING AND SCALING INPUTS ICONs < done
//add hover state to upload buttons < done

//TO DO
//potentially change pricing based on ink coverage by changing color variant to 'coverage' < future addition
//add msg prompt when phone is in landscape
//add loading wheel maybe? < don't think this is needed
//fix ui button alignment on mobile
//fix sticky product image on desktop
//maybe change upload UI button colours
// find the what's causing the gap
//maybe add 'reset' button to UI
//add logic to make sure upload change doesn't include "https://cdn.shopify.com/s/files"
//maybe fix so there's no horizontal spacing on full colour images

let timerRunning = false;
var divWidth;
var logoScale = 1;
var scaleCounter = 0;
var rotationCount = 0;
var previewImgInt = 1;
var startedFlag = 0;
let intervalID;
let imgIDcheck;
let imgChange;
let currentImg;
let imgOrder;
let imgIDs = [0, 0, 0, 0];
var logoAngles = [0, 0, 0, 0];
var inkCoverage = [0, 0, 0, 0];
var inkCoverageTotal;
var inkCoveragePattern;
var ScaledInkCoverage = [0,0,0,0];
var globalScale;
var globalRotate;

var logoAssets = [
  "https://cdn.shopify.com/s/files/1/0782/5634/1290/files/pattern-elements-03.png?v=1690214929",
  "https://cdn.shopify.com/s/files/1/0782/5634/1290/files/pattern-elements-01.png?v=1690214929",
  "https://cdn.shopify.com/s/files/1/0782/5634/1290/files/pattern-elements-02.png?v=1690214929",
  "https://cdn.shopify.com/s/files/1/0782/5634/1290/files/pattern-elements-04.png?v=1690214930",
];

document.body.innerHTML = document.body.innerHTML.replaceAll('&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;', '');


$(document).ready(function () {
  $(".swatchComponent").addClass("swatches-disabled");
  paperSquarify();
  patternSelect();
  paperSelect();
    paperSizeSelect();
  $(".sizeRadio").change(sizeSelect);
  $(".inputColor").change(patternSelect);
  $(".product-form__input").change(paperSelect);
    $(".product-form__input").change(paperSizeSelect);
  $(".mod-ui-button").click(modUI);
  $(".product__info-wrapper").click(function () {
    if (!$(".uploaderButton")[0] && $("div[data-ph-fieldname=LOGO1]")[0]) {
      hookInUploaded();
      patternSelect();
    }
    if (startedFlag == 0) {
      startedFlag = 1;
      $("#paper-area").addClass("paper-zoom");
      $("#paper-overlay").remove();
      $("#paper-scale").animate({ opacity: 1 }, 500);
      $("#paper-buttons").animate({ opacity: 1 }, 500);
      $("#paper-area").hover(
        function () {
          $("#paper-scale").animate({ opacity: 0 }, 200);
          $("#paper-buttons").animate({ opacity: 0 }, 200);
        },
        function () {
          $("#paper-scale").animate({ opacity: 1 }, 200);
          $("#paper-buttons").animate({ opacity: 1 }, 200);
        }
      );
    }
  });
});

  $("button").click(function () {
    console.log("BLINGBLING");
  });

  $(".start_design_btn").click(function () {
    $(".no-js-hidden").show();
    $(".shopify-block").show();
    $(".product-form ").show();
$(".product-form__quantity").show();
    
    $(".start_design_btn").remove();
  });



function uploadButtonListeners() {
  $("button").click(function () {
    if (timerRunning == true) {
      clearInterval(intervalID);
    }
    imgOrder = $(this).closest(".uploaderButton").attr("data-upload-order");
    if (imgOrder > 0) {
      imgIDcheck = $(this).closest(".uploaderButton").attr("id").substring(7);
      console.log("imgIDcheck" + imgIDcheck);
      timerRunning = true;
      imgChange = 0;
      intervalID = setInterval(uploadCheck, 200);
    }
  });
  $("div.uploadcare--widget__text").on("click", function () {
    if (timerRunning == true) {
      clearInterval(intervalID);
    }
    imgOrder = $(this).closest(".uploaderButton").attr("data-upload-order");
    console.log($(this).closest(".uploaderButton").attr("data-upload-order"));
    if (imgOrder > 0) {
      imgIDcheck = $(this).closest(".uploaderButton").attr("id").substring(7);
      if (typeof imgIDcheck === 'undefined') {
  console.log("BINGBONG?");
}
else{
      timerRunning = true;
      imgChange = 1;
      intervalID = setInterval(uploadCheck, 200);
}

    }
  });
}


function uploadCheck() {
    let tmpURL = $("#previewImages_" + imgIDcheck +" > div > div > div > div").css('background-image');
console.log(imgIDcheck);

  if (tmpURL.length > 4 && imgChange == 0) {
        clearInterval(intervalID);
        timerRunning = false;
    tmpURL = tmpURL.replace('url(','').replace(')','');
    tmpURL = tmpURL.replace("lightest", "best");
    tmpURL = tmpURL.replace('"', '');

    logoAssets[imgOrder - 1] = tmpURL;
    console.log(logoAssets[imgOrder - 1]);

    imgSelector = "img[data-field-id=" + imgIDcheck + "]";

  
    getInkCoverage(logoAssets[imgOrder - 1]).then(function(ratio) {
        inkCoverage[imgOrder - 1] = ratio;
        console.log('logo:'+(imgOrder - 1)+" "+inkCoverage[imgOrder - 1]+"%");
    });

    patternSelect();
  } else if ( tmpURL.length > 4 && imgChange == 1
  ) {
    //add logic to make sure change doesn't include "https://cdn.shopify.com/s/files"
    if (
      $("img[data-field-id=" + imgIDcheck + "]")
        .attr("src")
        .substring(0, 57) != logoAssets[imgOrder - 1].substring(0, 57)
    ) {
      imgChange = 0;
      $("img[data-field-id=" + imgIDcheck + "]").attr("width", "auto");
      tmpURL = $("img[data-field-id=" + imgIDcheck + "]").attr("src");
      logoAssets[imgOrder - 1] = tmpURL.replace("100x100", "600x600");
    }
  }
}

$(window).resize(function () {
  paperSquarify();
});




function paperSquarify() {
  divWidth = $("#paper-area").width();
  $("#paper-area").height((2 / 3) * divWidth);
  $("#paper-wrapper").height((2 / 3) * divWidth);
}

function paperSelect() {
  selected_value = $("input[name='Color']:checked").val();
  $(".uploaded-img").removeClass("white-ink-only");
  switch (selected_value) {
    case "Natural Kraft":
      $("#paper-area").css("background-color", "tan");
      $("#paper-wrapper").css("background-color", "tan");
      $("#paper-overlay").css("background-color", "tan");
      break;
    case "White Kraft":
      $("#paper-area").css("background-color", "#f7f7f7");
      $("#paper-wrapper").css("background-color", "#f7f7f7");
      $("#paper-overlay").css("background-color", "#f7f7f7");
      break;
    case "Polycoated Natural Kraft":
      $("#paper-area").css("background-color", "tan");
      $("#paper-wrapper").css("background-color", "tan");
      $("#paper-overlay").css("background-color", "tan");
      break;
    case "Polycoated White Kraft":
      $("#paper-area").css("background-color", "#f7f7f7");
      $("#paper-wrapper").css("background-color", "#f7f7f7");
      $("#paper-overlay").css("background-color", "#f7f7f7");
      break;
    case "Black Kraft":
      $("#paper-area").css("background-color", "black");
      $("#paper-wrapper").css("background-color", "black");
      $(".uploaded-img").addClass("white-ink-only");
      break;
  }
  updatePrintParams();
}

function paperSizeSelect() {
  selected_value = $("input[name='Size']:checked").val();
  switch (selected_value) {
    case '50 @ 24" x 24"':
      $("#scaleText > p").text('24"');
      break;
    case '250 @ 24" x 24"':
      $("#scaleText > p").text('24"');
      break;
    case '375 @ 24" x 24"':
      $("#scaleText > p").text('24"');
      break;
    case '250 @ 24" x 30"':
      $("#scaleText > p").text('30"');
      break;
          case '24\" x 100\'':
      $("#scaleText > p").text('24"');
      break;
          case '24\" x 500\'':
      $("#scaleText > p").text('24"');
      break;
          case '24\" x 750\'':
      $("#scaleText > p").text('24"');
      break;
    case '30\" x 500\'':
      $("#scaleText > p").text('30"');
      break;
  }
  updatePrintParams();
}
function sizeSelect() {
  selected_value = $("input.sizeRadio:checked").val();
  switch (selected_value) {
    case "S":
      $(".paper-row").height("11.1%");
      $(".paper-row").width("108%");
      $(".uploaded-image-wrap").width("7.05%");
      break;
    case "M":
      $(".paper-row").height("14.28%");
      $(".paper-row").width("157%");
      $(".uploaded-image-wrap").width("6.29%");
      break;
    case "L":
      $(".paper-row").height("20%");
      $(".paper-row").width("201%");
      $(".uploaded-image-wrap").width("7.05%");
      break;
          case "XL":
      $(".paper-row").height("49%");
      $(".paper-row").width("402%");
      $(".uploaded-image-wrap").width("7.143%");
      break;
  }

  //   switch (selected_value) {
  //   case "S":
  //     $(".paper-row").height("11.1%");
  //     $(".paper-row").width("108%");
  //     $(".uploaded-image-wrap").width("6.83%");
  //     break;
  //   case "M":
  //     $(".paper-row").height("14.28%");
  //     $(".paper-row").width("157%");
  //     $(".uploaded-image-wrap").width("6.07%");
  //     break;
  //   case "L":
  //     $(".paper-row").height("20%");
  //     $(".paper-row").width("201%");
  //     $(".uploaded-image-wrap").width("6.64%");
  //     break;
  //         case "XL":
  //     $(".paper-row").height("35%");
  //     $(".paper-row").width("402%");
  //     $(".uploaded-image-wrap").width("6.64%");
  //     break;
  // }
  updatePrintParams();
}

function hookInUploaded() {
  console.log("am I running?");
  $("div[data-ph-fieldname=LOGO1]").addClass("uploaderButton");
  $("div[data-ph-fieldname=LOGO2]").addClass("uploaderButton");
  $("div[data-ph-fieldname=LOGO3]").addClass("uploaderButton");
  $("div[data-ph-fieldname=LOGO4]").addClass("uploaderButton");
  $("div[data-ph-fieldname=LOGO1]").attr("data-upload-order", "1");
  $("div[data-ph-fieldname=LOGO2]").attr("data-upload-order", "2");
  $("div[data-ph-fieldname=LOGO3]").attr("data-upload-order", "3");
  $("div[data-ph-fieldname=LOGO4]").attr("data-upload-order", "4");
  imgIDs[0] = $("div[data-ph-fieldname=LOGO1]").attr("id").substring(7);
  imgIDs[1] = $("div[data-ph-fieldname=LOGO2]").attr("id").substring(7);
  imgIDs[2] = $("div[data-ph-fieldname=LOGO3]").attr("id").substring(7);
  imgIDs[3] = $("div[data-ph-fieldname=LOGO4]").attr("id").substring(7);
  //$(".shopify-app-block").css({ height: "auto", opacity: "100%" });
  $(".swatchComponent").removeClass("swatches-disabled");
  uploadButtonListeners();
  $(".uploaderButton").hide();
}

function patternSelect() {
  selected_value = $("input.inputColor:checked").val();
  selected_value = selected_value.substr(selected_value.length - 2);
  $(".uploaded-image-wrap").show();
  $(".uploaded-img").show();
  $(".uploaded-img").css(
    "transform",
    "translate(-50%, -50%) scale(" +
      (logoScale + scaleCounter) +
      ") rotate(" +
      logoAngles[0] +
      "deg)"
  );

  $(".uploaded-img").attr("src", logoAssets[0]);

  if (!$(".uploaderButton")[0] && $("div[data-ph-fieldname=LOGO1]")[0]) {
    hookInUploaded();
  }
  $(".uploaderButton").hide();

  $(".uploadcare--widget__button_type_open").css(
    "color",
    "rgb(var(--color-foreground)) !important;"
  );
  $(".paper-row").css("margin-left", "0");
  $('div > [data-rows="1"] > img').css("opacity", "1");
  switch (selected_value) {
    case "01":
      $("div[data-ph-fieldname=LOGO1]").show();
inkCoveragePattern = (ScaledInkCoverage[0]*4)/4;
      break;
    case "02":
      $("div[data-ph-fieldname=LOGO1]").show();
      $('div > [data-rows="2"] > img').hide();
      $('div > [data-rows="4"] > img').hide();
      $('div > [data-rows="6"] > img').hide();
      $('div > [data-rows="8"] > img').hide();
      inkCoveragePattern = (ScaledInkCoverage[0]*2)/4;
      break;
    case "03":
      $("div[data-ph-fieldname=LOGO1]").show();
      $('div > [data-columns="2"] > img').hide();
      $('div > [data-columns="4"] > img').hide();
      $('div > [data-columns="6"] > img').hide();
      $('div > [data-columns="8"] > img').hide();
      $('div > [data-columns="10"] > img').hide();
      $('div > [data-columns="12"] > img').hide();
      inkCoveragePattern = (ScaledInkCoverage[0]*2)/4;
      break;
    case "04":
      $("div[data-ph-fieldname=LOGO1]").show();
      $('div > [data-element="b"] > img').hide();
      $('div > [data-element="c"] > img').hide();
      inkCoveragePattern = (ScaledInkCoverage[0]*2)/4;
      break;
    case "05":
      $("div[data-ph-fieldname=LOGO1]").show();
      $("div[data-ph-fieldname=LOGO2]").show();
      $('div > [data-element="b"] > img').attr("src", logoAssets[1]);
      $('div > [data-element="c"] > img').attr("src", logoAssets[1]);
      inkCoveragePattern = ((ScaledInkCoverage[0]*2)+(ScaledInkCoverage[1]*2))/4;
      break;
    case "06":
      $("div[data-ph-fieldname=LOGO1]").show();
      $("div[data-ph-fieldname=LOGO2]").show();
      $("div[data-ph-fieldname=LOGO3]").show();
      $("div[data-ph-fieldname=LOGO4]").show();
      $('div > [data-element="b"] > img').attr("src", logoAssets[1]);
      $('div > [data-element="c"] > img').attr("src", logoAssets[2]);
      $('div > [data-element="d"] > img').attr("src", logoAssets[3]);
      inkCoveragePattern = (ScaledInkCoverage[0]+inkCoverage[1]+inkCoverage[2]+inkCoverage[3])/4;
      break;
    case "07":
      $(".uploaded-img").hide();
      $("div[data-ph-fieldname=LOGO1]").show();
      $('div > [data-element="a"] > img').show();
      inkCoveragePattern = inkCoverage[0]/4;
      break;
    case "08":
      $("div[data-ph-fieldname=LOGO1]").show();
      $("#paper-row-2").css("margin-left", "-3.8%");
      $("#paper-row-4").css("margin-left", "-3.8%");
      $("#paper-row-6").css("margin-left", "-3.8%");
      $("#paper-row-8").css("margin-left", "-3.8%");
      inkCoveragePattern = (ScaledInkCoverage[0]*4)/4;
      break;
    case "09":
      $("div[data-ph-fieldname=LOGO1]").show();
      $("#paper-row-2").css("margin-left", "-2.5%");
      $("#paper-row-3").css("margin-left", "-5%");
      $("#paper-row-5").css("margin-left", "-2.5%");
      $("#paper-row-6").css("margin-left", "-5%");
      $("#paper-row-8").css("margin-left", "-2.5%");
      $("#paper-row-9").css("margin-left", "-5%");
      inkCoveragePattern = (ScaledInkCoverage[0]*4)/4;
      break;

    case "10":
      $("div[data-ph-fieldname=LOGO1]").show();
      $('div > [data-element="a"] > img').css({
        transform:
          "translate(-50%, -50%) scale(" +
          (logoScale + scaleCounter) +
          ") rotate(" +
          (logoAngles[0] - 45) +
          "deg)",
      });
      $('div > [data-element="b"] > img').css({
        transform:
          "translate(-50%, -50%) scale(" +
          (logoScale + scaleCounter) +
          ") rotate(" +
          (logoAngles[0] + 45) +
          "deg)",
      });
      $('div > [data-element="c"] > img').css({
        transform:
          "translate(-50%, -50%) scale(" +
          (logoScale + scaleCounter) +
          ") rotate(" +
          (logoAngles[0] + 225) +
          "deg)",
      });
      $('div > [data-element="d"] > img').css({
        transform:
          "translate(-50%, -50%) scale(" +
          (logoScale + scaleCounter) +
          ") rotate(" +
          (logoAngles[0] + 135) +
          "deg)",
      });
inkCoveragePattern = (ScaledInkCoverage[0]*4)/4;
      break;

    case "11":
      $("div[data-ph-fieldname=LOGO1]").show();
      $('div > [data-element="a"] > img').css({
        transform:
          "translate(-50%, -50%) scale(" +
          (logoScale + scaleCounter) +
          ") rotate(" +
          logoAngles[0] +
          "deg)",
      });
      $('div > [data-element="b"] > img').css({
        transform:
          "translate(-50%, -50%) scale(" +
          (logoScale + scaleCounter) +
          ") rotate(" +
          (logoAngles[0] + 90) +
          "deg)",
      });
      $('div > [data-element="d"] > img').css({
        transform:
          "translate(-50%, -50%) scale(" +
          (logoScale + scaleCounter) +
          ") rotate(" +
          (logoAngles[0] + 180) +
          "deg)",
      });
      $('div > [data-element="c"] > img').css({
        transform:
          "translate(-50%, -50%) scale(" +
          (logoScale + scaleCounter) +
          ") rotate(" +
          (logoAngles[0] + 270) +
          "deg)",
      });
inkCoveragePattern = (ScaledInkCoverage[0]*4)/4;
      break;

    case "12":
      $("div[data-ph-fieldname=LOGO1]").show();
      $("div[data-ph-fieldname=LOGO2]").show();
      $('div > [data-element="b"] > img').hide();
      $('div > [data-element="c"] > img').hide();
      $('div > [data-element="d"] > img').attr("src", logoAssets[1]);
      inkCoveragePattern = inkCoverage[0]+inkCoverage[1];
      break;
  }
    console.log('array: '+ inkCoverage);
    console.log('array: '+ ScaledInkCoverage);
  console.log('total cover: '+ inkCoveragePattern);
  updatePrintParams();
}

function scaleCheck(){
      if(scaleCounter>=0){
          console.log("BIGOS");
          $("#big-btn").prop("disabled",true);
    }
    else{
          $("#big-btn").prop("disabled",false);
    }
}

function modUI() {
  var btnName = this.id;
scaleCheck();
  switch (btnName) {
    case "big-btn":
      scaleCounter += 0.1;
      rotationCount = 0;
      break;
    case "small-btn":
      scaleCounter -= 0.1;
      rotationCount = 0;
      break;
    case "left-btn":
      rotationCount = -15;
      break;
    case "right-btn":
      rotationCount = 15;
      break;
  }
  scaleCheck();
  logoAngles[0] =
    getRotationDegrees($('div > [data-element="a"] > img')) + rotationCount;
  console.log("A:" + logoAngles[0]);
  $('div > [data-element="a"] > img').css(
    "transform",
    "translate(-50%, -50%) scale(" +
      (logoScale + scaleCounter) +
      ") rotate(" +
      logoAngles[0] +
      "deg)"
  );
  logoAngles[1] =
    getRotationDegrees($('div > [data-element="b"] > img')) + rotationCount;
  console.log("B:" + logoAngles[1]);
  $('div > [data-element="b"] > img').css(
    "transform",
    "translate(-50%, -50%) scale(" +
      (logoScale + scaleCounter) +
      ") rotate(" +
      logoAngles[1] +
      "deg)"
  );
  logoAngles[2] =
    getRotationDegrees($('div > [data-element="c"] > img')) + rotationCount;
  console.log("C:" + logoAngles[2]);
  $('div > [data-element="c"] > img').css(
    "transform",
    "translate(-50%, -50%) scale(" +
      (logoScale + scaleCounter) +
      ") rotate(" +
      logoAngles[2] +
      "deg)"
  );
  logoAngles[3] =
    getRotationDegrees($('div > [data-element="d"] > img')) + rotationCount;
  console.log("D:" + logoAngles[3]);
  $('div > [data-element="d"] > img').css(
    "transform",
    "translate(-50%, -50%) scale(" +
      (logoScale + scaleCounter) +
      ") rotate(" +
      logoAngles[3] +
      "deg)"
  );

  $("#element-size").val(logoScale + scaleCounter);
  $("#element-rotation").val(logoAngles[0]);
      updateInkCoverageScale();  
  patternSelect();

}

function getRotationDegrees(obj) {
  var matrix =
    obj.css("-webkit-transform") ||
    obj.css("-moz-transform") ||
    obj.css("-ms-transform") ||
    obj.css("-o-transform") ||
    obj.css("transform");
  if (matrix !== "none") {
    var values = matrix.split("(")[1].split(")")[0].split(",");
    var a = values[0];
    var b = values[1];
    var angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));
  } else {
    var angle = 0;
  }
  return angle < 0 ? angle + 360 : angle;
}

function updateInkCoverageScale(){
      for (var i = 0; i < 4; i++) {
    ScaledInkCoverage[i] = inkCoverage[i] * (logoScale + scaleCounter);
}
  recordDesignData();
}

function recordDesignData(){
const transform = $('.uploaded-img').css('transform');

// Note: jQuery/browser returns a matrix, so it's easier to read from the style attribute directly
const style = $('.uploaded-img').attr('style');

const scale = style.match(/scale\(([\d.]+)\)/) ? parseFloat(RegExp.$1) : 1;
const rotate = style.match(/rotate\(([\d.]+)deg\)/) ? parseFloat(RegExp.$1) : 0;
globalScale = scale;
globalRotate = rotate;
var currentScale = logoScale + scaleCounter;
console.log(currentScale);
console.log('Scale:', scale);   // 1.4
console.log('Rotate:', rotate);

$('#custom-text-data-value').val(scale + ',' + rotate + ',' + inkCoveragePattern);

}

async function getInkCoverage(imageSrc, threshold = 240) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = imageSrc;

        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);

            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            const totalPixels = canvas.width * canvas.height;
            let coloredPixels = 0;

            for (let i = 0; i < data.length; i += 4) {
                const r = data[i];
                const g = data[i + 1];
                const b = data[i + 2];
                const a = data[i + 3];

                // Skip transparent pixels
                if (a < 10) continue;

                // Skip white/near-white pixels
                if (r > threshold && g > threshold && b > threshold) continue;

                coloredPixels++;
            }

            const ratio = coloredPixels / totalPixels;
            console.log('Ink coverage: ' + (ratio * 100).toFixed(2) + '%');
            resolve(ratio);
        };

        img.onerror = reject;
    });
}

/**
 * hanagami — Print URL Generator
 * 
 * Reads the current product page state and builds the print-generate URL.
 * Writes the result to input[name="properties[_DesignData]"]
 * 
 * ASSUMPTIONS (verify these):
 *   - STOCK values: kraft, white, polykraft, polywhite
 *   - ROT = globalRotate, ZOOM = globalScale (not swapped)
 *   - Variant selectors use Shopify Dawn-style radio inputs
 *   - Elements with [data-img-prop="0..3"] exist and carry data-img-id
 */

function generatePrintURL() {
  const BASE = 'https://hanagami.ca/pages/print-generate';
  const KEY  = 'dingdongbingbong';
  // ── LOGO 1–4 ─────────────────────────────────────────────
  // Pull Uploadcare UUIDs from elements with data-img-prop attributes
  const getLogo = (n) =>
    document.querySelector(`[data-img-prop="${n}"]`)?.getAttribute('data-img-id') || '';

  const logo1 = getLogo(0);
  const logo2 = getLogo(1);
  const logo3 = getLogo(2);
  const logo4 = getLogo(3);

  // ── SELECTED VARIANT OPTIONS ──────────────────────────────
  // Helper: get the checked radio value for a given option fieldset.
  // Shopify Dawn wraps each option group in a fieldset or div.
  // We try multiple selector patterns to be safe.
  function getSelectedOption(optionName) {
    // Pattern 1: Dawn-style radio buttons
    const radio = document.querySelector(
      `fieldset input[type="radio"][name^="${optionName}"]:checked,` +
      `fieldset input[type="radio"][value][data-option-name="${optionName}"]:checked`
    );
    if (radio) return radio.value;

    // Pattern 2: Look for an active swatch/button with the option name in its container
    const container = Array.from(document.querySelectorAll('fieldset, .product-form__input'))
      .find(el => {
        const legend = el.querySelector('legend, .form__label');
        return legend && legend.textContent.trim().startsWith(optionName);
      });
    if (container) {
      const checked = container.querySelector('input:checked');
      if (checked) return checked.value;
    }

    return '';
  }

  const selectedColor = getSelectedOption('Color');
  const selectedSize  = getSelectedOption('Size');
  const selectedStyle = getSelectedOption('Style');

  // ── QTY — last number from Size (e.g. "24\" x 100'" → "100") ──
  const qtyMatch = selectedSize.match(/x\s*(\d+)/);
  const qty = qtyMatch ? qtyMatch[1] : '';

  // ── STOCK — map Color to stock code ───────────────────────
  // ⚠️  Confirm these values match what print-generate expects
  const STOCK_MAP = {
    'Natural Kraft':            'kraft',
    'White Kraft':              'white',
    'Polycoated Natural Kraft': 'polykraft',
    'Polycoated White Kraft':   'polywhite',
  };
  const stock = STOCK_MAP[selectedColor] || 'kraft';

  // ── PAT — extract pattern number from Style ───────────────
  // "patterns03" → "03"
  const patMatch = selectedStyle.match(/patterns(\d+)/);
  const pat = patMatch ? patMatch[1] : '01';

  // ── SIZE — Pattern Size selector ──────────────────────────
  const selectedPatSize = getSelectedOption('Pattern Size');
  const SIZE_MAP = {
    'Small':       'S',
    'Medium':      'M',
    'Large':       'L',
    'Extra Large': 'XL',
  };
  const size = SIZE_MAP[selectedPatSize] || 'M';

  // ── ROT & ZOOM — from global JS variables ─────────────────
  // If these are undefined, fall back to the element-rotation / element-size inputs
  let rot  = (typeof globalRotate !== 'undefined') ? globalRotate : 0;
  let zoom = (typeof globalScale  !== 'undefined') ? globalScale  : 1;

  // Fallback: try reading from named inputs if globals aren't set
  if (rot === 0) {
    const rotInput = document.querySelector('[name="element-rotation"], #element-rotation');
    if (rotInput) rot = rotInput.value;
  }
  if (zoom === 1) {
    const zoomInput = document.querySelector('[name="element-size"], #element-size');
    if (zoomInput) zoom = zoomInput.value;
  }

  // ── BUILD URL ─────────────────────────────────────────────
  const params = new URLSearchParams({
    KEY:   KEY,
    QTY:   qty,
    STOCK: stock,
    LOGO1: logo1,
    LOGO2: logo2,
    LOGO3: logo3,
    LOGO4: logo4,
    PAT:   pat,
    SIZE:  size,
    ZOOM:  zoom,
    ROT:   rot,
  });

  const finalURL = `${BASE}?${params.toString()}`;

  // ── WRITE TO HIDDEN INPUT ─────────────────────────────────
  const input = document.querySelector('input[name="properties[_DesignData]"]');
  if (input) {
    input.value = finalURL;
    // console.log('[hanagami] DesignData URL set:', finalURL);
  } else {
    console.warn('[hanagami] Could not find input[name="properties[_DesignData]"]');
  }
console.log(finalURL);
  return finalURL;
}


// ── TRIGGER: click / tap ────────────────────────────────────
// Option A: Attach to Add-to-Cart button (most common)
// Option B: Attach to a dedicated "Generate" button
// Adjust the selector below to match your trigger element.

document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.querySelector(
    'button[name="add"], button.product-form__submit, .btn-generate-url'
  );
  if (trigger) {
    trigger.addEventListener('click', (e) => {
      generatePrintURL();
      // Don't preventDefault — let the form submit normally after URL is set
    });
  } else {
    console.warn('[hanagami] No trigger button found for generatePrintURL');
  }
});


// ── PRINT PARAMS AUTO-UPDATE ─────────────────────────
function extractUUID(url) {
  if (!url) return '';
  if (!url.includes('/')) return url;
  const match = url.match(/ucarecdn\.com\/([a-f0-9-]+)/i);
  if (match) return match[1];
  return url;
}

// ── PRINT PARAMS AUTO-UPDATE ─────────────────────────
function extractUUID(url) {
  if (!url) return '';
  // If it's a default Shopify asset, return empty
  if (url.includes('cdn.shopify.com')) return '';
  if (!url.includes('/')) return url;
  const match = url.match(/ucarecdn\.com\/([a-f0-9-]+)/i);
  if (match) return match[1];
  return url;
}

function updatePrintParams() {
  const logo1 = logoAssets[0] ? extractUUID(logoAssets[0]) : '';
  const logo2 = logoAssets[1] ? extractUUID(logoAssets[1]) : '';
  const logo3 = logoAssets[2] ? extractUUID(logoAssets[2]) : '';
  const logo4 = logoAssets[3] ? extractUUID(logoAssets[3]) : '';

  const selectedColor = $("input[name='Color']:checked").val() || '';
  const STOCK_MAP = {
    'Natural Kraft': 'kraft',
    'White Kraft': 'white',
    'Polycoated Natural Kraft': 'polykraft',
    'Polycoated White Kraft': 'polywhite',
  };
  const stock = STOCK_MAP[selectedColor] || 'kraft';

  const selectedSize = $("input[name='Size']:checked").val() || '';
  const qtyMatch = selectedSize.match(/x\s*(\d+)/);
  const qty = qtyMatch ? qtyMatch[1] : '100';

  const selectedStyle = $("input.inputColor:checked").val() || 'patterns01';
  const patMatch = selectedStyle.match(/patterns(\d+)/);
  const pat = patMatch ? patMatch[1] : '01';

  // Fix: Use Pattern Size field and map to S/M/L/XL
  const selectedPatSize = $("input[name='Pattern Size']:checked").val() || 'Medium';
  const SIZE_MAP = {
    'Small': 'S',
    'Medium': 'M',
    'Large': 'L',
    'Extra Large': 'XL',
  };
  const size = SIZE_MAP[selectedPatSize] || 'M';

  const zoom = (logoScale + scaleCounter).toFixed(2);
  const rot = logoAngles[0] || 0;

  const params = new URLSearchParams({
    QTY: qty,
    STOCK: stock,
    LOGO1: logo1,
    LOGO2: logo2,
    LOGO3: logo3,
    LOGO4: logo4,
    PAT: pat,
    SIZE: size,
    ZOOM: zoom,
    ROT: rot,
  });

  if (!logo1) params.delete('LOGO1');
  if (!logo2) params.delete('LOGO2');
  if (!logo3) params.delete('LOGO3');
  if (!logo4) params.delete('LOGO4');

  const paramsString = params.toString();
  $('#print-params').val(paramsString);
  return paramsString;
}